import React from 'react';
import { Modal, Button } from 'react-bootstrap';

class OnHold extends React.Component {
  render() {
    return (
      <Modal {...this.props} bsSize="large">
        <Modal.Header className="modal-header-primary">
          <Modal.Title id="contained-modal-title-lg">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i className="fa fa-close"> </i>
            </button>
            {this.props.coursename}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.commentList?.length > 0 && (
            <div className="form-group">
              <div className="col-sm-10">
                <table
                  id="tblDocuments"
                  name="tblDocuments"
                  className="table table-striped table-bordered table-hover table-condensed"
                >
                  <thead>
                    <tr className="header">
                      <th>Date</th>
                      <th>Comments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.commentList?.map((item) => (
                      <tr>
                        <td>{item.CreatedDate}</td>
                        <td>{item.Comment} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="form-group input-modal col-md-12">
            <div className="label-modal">
              <label>Query</label>
            </div>
            <textarea
              className="form-control"
              style={{ overflowX: 'hidden' }}
              id="Query"
              rows="6"
              onChange={(e) => this.props.handleCommentsChange(e.target.value)}
              value={this.props.comments}
              placeholder="Your Query here"
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-warning" onClick={this.props.onHide}>
            Cancel
          </Button>
          <Button
            className="btn btn-success"
            onClick={this.props.handleCPDQueueUpdate}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default OnHold;
